import { NgModule } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDividerModule } from '@angular/material/divider';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatGridListModule} from '@angular/material/grid-list';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomPaginator } from './shared/utils/CustomPaginatorConfiguration';
import { MatBadgeModule } from '@angular/material/badge';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

@NgModule({
    exports: [
        MatToolbarModule,
        MatRadioModule,
        MatStepperModule,
        MatTabsModule,
        MatButtonModule,
        MatInputModule,
        MatFormFieldModule,
        MatNativeDateModule,
        MatCardModule,
        MatProgressSpinnerModule,
        MatTableModule,
        MatSelectModule,
        MatCheckboxModule,
        MatIconModule,
        MatGridListModule,
        MatMenuModule,
        MatPaginatorModule,
        MatButtonToggleModule,
        MatSlideToggleModule,
        MatExpansionModule,
        MatTooltipModule,
        MatDialogModule,
        MatListModule,
        MatProgressBarModule,
        MatDividerModule,
        MatDatepickerModule,
        MatSidenavModule,
        MatSnackBarModule,
        MatPaginatorModule,
        MatBadgeModule,
        MatChipsModule,
        MatAutocompleteModule
    ],
    providers: [
        MatDatepickerModule,
        MatNativeDateModule,
        { provide: MatPaginatorIntl, useValue: CustomPaginator() }
    ]
})
export class MaterialModule { }
